import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Enum } from './enum';
export var PositionBaseType = Enum({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
});
export var PositionType = Enum(_objectSpread(_objectSpread({}, PositionBaseType), {}, {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  LEFT_TOP: 'left-top',
  LEFT_BOTTOM: 'left-bottom',
  RIGHT_TOP: 'right-top',
  RIGHT_BOTTOM: 'right-bottom',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right'
}));
export function isPositionHorizontal(position) {
  return position === PositionType.TOP || position === PositionType.TOP_LEFT || position === PositionType.TOP_RIGHT || position === PositionType.BOTTOM || position === PositionType.BOTTOM_LEFT || position === PositionType.BOTTOM_RIGHT;
}
export function isPositionVertical(position) {
  return position === PositionType.LEFT || position === PositionType.LEFT_TOP || position === PositionType.LEFT_BOTTOM || position === PositionType.RIGHT || position === PositionType.RIGHT_TOP || position === PositionType.RIGHT_BOTTOM;
}
export function getOppositePosition(position) {
  switch (position) {
    case PositionBaseType.TOP:
      return PositionBaseType.BOTTOM;
    case PositionBaseType.BOTTOM:
      return PositionBaseType.TOP;
    case PositionBaseType.LEFT:
      return PositionBaseType.RIGHT;
    case PositionBaseType.RIGHT:
      return PositionBaseType.LEFT;
    default:
      return assertNever(position);
  }
}
export function getPositionBase(position) {
  switch (position) {
    case PositionType.TOP:
    case PositionType.TOP_LEFT:
    case PositionType.TOP_RIGHT:
      return PositionType.TOP;
    case PositionType.BOTTOM:
    case PositionType.BOTTOM_LEFT:
    case PositionType.BOTTOM_RIGHT:
      return PositionType.BOTTOM;
    case PositionType.LEFT:
    case PositionType.LEFT_TOP:
    case PositionType.LEFT_BOTTOM:
      return PositionType.LEFT;
    case PositionType.RIGHT:
    case PositionType.RIGHT_TOP:
    case PositionType.RIGHT_BOTTOM:
      return PositionType.RIGHT;
    default:
      return assertNever(position);
  }
}
function assertNever(x) {
  throw new Error('Unexpected position: ' + x);
}